import { useEffect, useState, useRef } from 'react'

import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js'
import { Radar } from 'react-chartjs-2'

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend)

export default function ResultsChart({ data, content, setScores, setAverage, setInfo }) {
  const scores = [
    data.slice(0, 4).reduce((rs, r) => {
      return r ? ++rs : --rs
    }, 0),
    data.slice(4, 8).reduce((rs, r) => {
      return r ? ++rs : --rs
    }, 0),
    data.slice(8, 12).reduce((rs, r) => {
      return r ? ++rs : --rs
    }, 0),
    data.slice(12, 16).reduce((rs, r) => {
      return r ? ++rs : --rs
    }, 0),
    data.slice(16, 20).reduce((rs, r) => {
      return r ? ++rs : --rs
    }, 0),
  ]

  const equivalentScores = scores.map((score) => {
    if (score === -4 || score === -3) {
      return 1
    }
    if (score === -2 || score === -1) {
      return 2
    }
    if (score === 0) {
      return 3
    }
    if (score === 1 || score === 2) {
      return 4
    }
    if (score === 3 || score === 4) {
      return 5
    }
    return null
  })

  function getAverage(equivalentScores) {
    const test = content?.introduction?.text?.includes('Management Aptitude Test')
    const quiz = content?.introduction?.text?.includes('Communication Style Quiz')
    const sum = equivalentScores.reduce((a, b) => a + b, 0)
    const avg = Math.round(sum / 5 || 0)
    if (typeof window !== 'undefined' && window.localStorage && avg !== null) {
      let scores = test
        ? JSON.parse(localStorage.getItem('testScores'))
        : quiz
          ? JSON.parse(localStorage.getItem('quizScores'))
          : null
      if (scores == null) scores = []
      if (scores.length > 9) scores = scores.slice(1)
      scores.push(avg)
      test
        ? localStorage.setItem('testScores', JSON.stringify(scores))
        : quiz
          ? localStorage.setItem('quizScores', JSON.stringify(scores))
          : null
      setAverage(avg)
      setScores(scores.reverse())
    }
  }

  function getResults(results, equivalentScores) {
    const mapping = {
      1: 'verylow',
      2: 'low',
      3: 'average',
      4: 'high',
      5: 'veryhigh',
    }

    return results.map((result, index) => {
      const score = equivalentScores[index]
      const description = mapping[score]
      return result[description]
    })
  }

  //const label = getResults(content.results, equivalentScores);

  function getDetailedInfo(content, scores) {
    const mapping = {
      1: 'verylow',
      2: 'low',
      3: 'average',
      4: 'high',
      5: 'veryhigh',
    }

    return scores?.map((score, index) => {
      const description = mapping[score] || null
      return description ? content.results[index][description] : null
    })
  }

  useEffect(() => {
    const info = getDetailedInfo(content, equivalentScores)
    getAverage(equivalentScores)
    setInfo(info)
  }, [])

  const labels = content.results.map((r, i) => {
    const emoji = r.block
    return emoji
  })

  const dataChart = {
    labels: labels,
    datasets: [
      {
        label: '  Score',
        data: equivalentScores,
        backgroundColor: '#0ac9ef80', //'rgba(255, 99, 132, 0.2)',
        borderColor: '#0ac9ef', //'rgba(255, 99, 132, 1)',
        borderWidth: 2.5,
      },
      /*{
          label: ' Last Score',
          data: equivalentScores,
          backgroundColor: "#4BB54380", //'rgba(255, 99, 132, 0.2)',
          borderColor: "#4BB543", //'rgba(255, 99, 132, 1)',
          borderWidth: 4,
        }*/
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      r: {
        angleLines: {
          display: true,
          lineWidth: 2,
          color: '#09323A10',
        },
        min: 0,
        max: 5,
        suggestedMin: 0,
        suggestedMax: 5,
        weight: 2,
        grid: {
          display: true,
          color: '#09323A10',
          lineWidth: 2,
        },
        ticks: {
          display: false,
          stepSize: 5,
        },
        pointLabels: {
          padding: 10,
          color: '#09323A',
          font: {
            size: 18,
            weight: 400,
          },
          centerPointLabels: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
        labels: {
          borderRadius: 8,
          color: 'red',
        },
      },
    },
  }

  return <Radar data={dataChart} options={options} />
}
